<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    :title="`Dashboards Access for ${email || uid}`"
    size="lg"
    @shown="focusSearchInput"
  >
    <b-form-group label="Search by name:">
      <b-form-input
        v-model="dashboardSearchName"
        ref="searchInput"
      />
    </b-form-group>
    <div v-if="uid && dashboards">
      <b-table
        striped
        hover
        :items="items"
        :fields="fields"
      >
        <template v-slot:cell(hasAccess)="row">
          <b-form-checkbox
            :checked="row.item.hasAccess"
            @change="removeDashboardAccess($event, row.item.dId)"
            :disabled="!row.item.hasAccess || isOwner(row.item.owner)"
          >
            <span v-if="isOwner(row.item.owner)">is owner</span>
          </b-form-checkbox>
        </template>

        <template v-slot:cell(edit)="row">
          <b-button size="sm" @click="row.toggleDetails" class="mr-2">
            <span v-if="row.detailsShowing">
              <icon name="long-arrow-up" />
              <span>Hide</span>
            </span>
            <span v-else>
              <icon name="long-arrow-down" />
              <span>Show</span>
            </span>
          </b-button>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-form
            :id="`d-edit-${row.item.dId}`"
            @submit.prevent="saveDashboardAccess(`d-edit-${row.item.dId}`, row.index)"
          >
            <b-form-group label="Role:">
              <b-form-select
                :options="roleOptions"
                class="js-role"
                :value="getRolesVal(row.item)"
                multiple
              ></b-form-select>
            </b-form-group>
            <b-button
              variant="primary"
              size="sm"
              type="submit"
            >
              Save
            </b-button>
          </b-form>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  props: ['dashboards', 'access'],
  data () {
    return {
      uid: null,
      email: null,
      fields: [
        { key: 'dName', label: 'Workspace Name' },
        { key: 'hasAccess', label: 'Has Access' },
        'edit'
      ],
      roleOptions: [
        { value: 'read', text: 'Regular' },
        { value: 'update', text: 'Workspace editor' },
        { value: 'manageUsers', text: 'User manager' }
      ],
      dashboardSearchName: null
    }
  },
  computed: {
    items () {
      const items = []

      for (let dId in this.dashboards) {
        const dashboard = this.dashboards[dId]
        let hasAccess = false

        if (this.access.Dashboard[this.uid] && this.access.Dashboard[this.uid][dId]) hasAccess = true
        if (dashboard.owner === this.uid) hasAccess = true

        if (
          !this.dashboardSearchName ||
          (dashboard.name.toLowerCase()).includes(this.dashboardSearchName.toLowerCase())
        ) {
          items.push({
            dId,
            owner: dashboard.owner,
            dName: dashboard.name,
            hasAccess
          })
        }
      }

      return items
    }
  },
  methods: {
    open (data) {
      this.uid = data.uid
      this.email = data.email

      if (this.$refs['modal']) this.$refs['modal'].show()
    },
    saveDashboardAccess (refKey, idx) {
      const form = $(`#${refKey}`)[0]
      const row = this.items[idx]
      const roles = $(form).find('.js-role').val()

      const newRules = {}

      for (let rule of roles) {
        newRules[rule] = true
      }

      const data = {
        uid: this.uid,
        dId: row.dId,
        rules: newRules
      }

      this.$parent.saveDashboardAccess(data)
    },
    removeDashboardAccess (val, dId) {
      const data = {
        uid: this.uid,
        dId
      }

      this.$parent.removeDashboardAccess(data)
    },
    isOwner (ownerId) {
      return (ownerId === this.uid) ? true : false
    },
    getRolesVal (item) {
      if (
        this.access.Dashboard[this.uid] &&
        this.access.Dashboard[this.uid][item.dId]
      ) {
        return Object.keys(this.access.Dashboard[this.uid][item.dId])
      }
      return []
    },
    focusSearchInput () {
      this.$refs.searchInput.focus()
    }
  }
}
</script>
